import { render, staticRenderFns } from "./AnalPratUtilComponent.vue?vue&type=template&id=3bcc6220&scoped=true"
import script from "./AnalPratUtilComponent.vue?vue&type=script&lang=js"
export * from "./AnalPratUtilComponent.vue?vue&type=script&lang=js"
import style0 from "./AnalPratUtilComponent.vue?vue&type=style&index=0&id=3bcc6220&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcc6220",
  null
  
)

export default component.exports